///<reference path="../types/schema.ts"/>
import * as React from 'react';
import {style} from 'typestyle';
import {colorWhite} from '../theme/color';
import {em, px} from 'csx';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {PageHomeJustAddedTracks} from './page-home-just-added-tracks';
import {observer} from 'mobx-react';
import {fontHeading} from '../theme/font';
import {center, horizontal, horizontallySpaced} from 'csstips';
import {ArtistSchema, TrackSchema} from '../types/schema';
import {ImagePreloader} from '../types/fn';

export interface PageHomeJustAddedModel {
  justAdded: Array<TrackSchema>;
};

export interface PageHomeJustAddedProps {
  model: PageHomeJustAddedModel;
  onClickLink(event: React.MouseEvent<any>): void;
  preload: ImagePreloader;
  PlayButton: any;
  AddRemove: any;
  Favourite: any;
  i18n?: {
    title: string;
  };
}

@observer
export class PageHomeJustAdded extends React.Component<PageHomeJustAddedProps, any> {
  render() {
    const { i18n = PageHomeJustAdded.i18n, model, PlayButton, Favourite, AddRemove, onClickLink, preload } = this.props;

    return (
      <div className={PageHomeJustAdded.styles.container}>
        <div><span>{i18n.title}</span></div>
        <PageHomeJustAddedTracks
          tracks={model.justAdded}
          PlayButton={PlayButton}
          AddRemove={AddRemove}
          Favourite={Favourite}
          onClickLink={onClickLink}
          preload={preload}
        />
      </div>
    )
  }

  static i18n = {
    title: 'Just added'
  };

  static styles = {
    container: style(
      {
        position: 'relative',
        color: colorWhite.toString(),
        fontWeight: 500,
        $nest: {
          '&> div:first-child': {
            ...horizontal,
            ...horizontallySpaced(5),
            ...center,
            margin: '0 0 20px 0',
            fontSize: px(20),
            fontFamily: fontHeading,
            letterSpacing: em(-0.0625)
          }
        }
      },
      mediaMobileOnly({
        $nest: {
          '&> div:first-child': {
            padding: '0 20px'
          }
        }
      }),
      mediaTablet({
        $nest: {
          '&> div:first-child': {
            padding: '0 40px'
          }
        }
      })
    )
  }
}